import type { GroupDetail } from 'models';
import { useMemo } from 'react';
import type { HierarchyItem } from 'ui';
import { images } from 'common/utils';
import { useGetGroupPreviewIcon, useGetGroupPreviewTypeName } from '../../../hooks';

export const useGetHierarchyTreeItems = ({
  getPathToGroupDetail,
  group,
}: {
  getPathToGroupDetail: (id: string) => string;
  group: GroupDetail;
}): HierarchyItem[] => {
  const getGroupPreviewTypeName = useGetGroupPreviewTypeName();
  const getGroupPreviewIcon = useGetGroupPreviewIcon();

  return useMemo(() => {
    const items: HierarchyItem[] = [];

    if (group.ancestors.length > 0) {
      for (const ancestor of group.ancestors) {
        items.push({
          alt: 'Group profile photo',
          avatarUrl: ancestor.logo?.url ?? images.default.groupProfilePhoto,
          id: ancestor.id,
          name: ancestor.name,
          path: getPathToGroupDetail(ancestor.id),
          tag: {
            children: getGroupPreviewTypeName({ groupType: ancestor.groupType }),
            icon: getGroupPreviewIcon({ groupType: ancestor.groupType }),
          },
        });
      }
    }

    items.push({
      alt: 'Group profile photo',
      avatarUrl: group.logo?.url ?? images.default.groupProfilePhoto,
      id: group.id,
      name: group.name,
      tag: {
        children: getGroupPreviewTypeName({ groupType: group.groupType }),
        icon: getGroupPreviewIcon({ groupType: group.groupType }),
      },
    });

    return items;
  }, [group, getGroupPreviewTypeName, getPathToGroupDetail, getGroupPreviewIcon]);
};
